import styled from "styled-components";

export const Styles = styled.div`
  height: 100%;
  padding: 1em;
  display: flex;
  justify-content: center;
  align-items: center;
`